import * as swcHelpers from '@swc/helpers';
import { createSelector } from 'reselect';
import { uninitState, idleState } from '@grandvisionhq/state';
import { isUninitialized as isUninitialized$1, AuthState, isLoggedIn as isLoggedIn$1 } from './state.js';

const getAuth = (state)=>state.auth
;
const getAuthType = createSelector(getAuth, (auth)=>auth.type
);
const getDisableAddressEditing = createSelector(getAuth, (auth)=>auth.disableAddressEditing
);
/**
 * This will return true for all states except uninitialized
 */ const isInitialized = createSelector(getAuth, (auth)=>auth && !isUninitialized$1(auth)
);
const isUninitialized = createSelector(getAuth, (auth)=>isUninitialized$1(auth)
);
const isLoggedIn = createSelector(getAuth, (auth)=>auth && auth.state === AuthState.LoggedIn
);
const isLoggedOut = createSelector(getAuth, (auth)=>auth && auth.state === AuthState.LoggedOut
);
const getRouting = createSelector(getAuth, (auth)=>isUninitialized$1(auth) ? undefined : auth.routing
);
const getRoutes = createSelector(getRouting, (routing)=>routing ? routing.routes : undefined
);
const getBasePath = createSelector(getRouting, (routing)=>routing ? routing.basePath : undefined
);
const getCheckoutRoute = createSelector(getRouting, (routing)=>routing ? routing.checkoutRoute : undefined
);
const getFormattedRoutes = createSelector(getRoutes, getBasePath, (routes, basePath)=>{
    if (!routes || !basePath) {
        return undefined;
    }
    return Object.entries(routes).reduce((formattedRoutes, [name, route])=>swcHelpers.objectSpread({
            [name]: `/${basePath}/${route}`
        }, formattedRoutes)
    , {});
});
const getDomain = createSelector(isInitialized, getAuth, (isInitialized1, auth)=>isInitialized1 ? auth.domain : undefined
);
const getCustomDomain = createSelector(isInitialized, getAuth, (isInitialized2, auth)=>isInitialized2 ? auth.customDomain : undefined
);
const getUserId = createSelector(getAuth, (auth)=>isLoggedIn$1(auth) ? auth.userId : undefined
);
/**
 * Opt-In selectors for OpCo configured opt-ins
 */ /**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const getOptIns = createSelector(getAuth, (auth)=>!isUninitialized$1(auth) ? auth.optIns : []
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const getOptInsForSignup = createSelector(getOptIns, (optIns)=>optIns.filter((o)=>o.isInSignup
    )
);
const getUserSettings = createSelector(getAuth, (auth)=>isLoggedIn$1(auth) ? auth.userSettings : undefined
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getChangedOptIns = createSelector(getUserSettings, (userSettings)=>userSettings ? userSettings.optInsState.changedOptIns : {}
);
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getOptInsOnServer = createSelector(getUserSettings, (userSettings)=>{
    return userSettings ? userSettings === null || userSettings === void 0 ? void 0 : userSettings.optInsState.optInsOnServer : uninitState();
});
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-opt-ins.ts
 */ const getUpdateOptInsCall = createSelector(getUserSettings, (userSettings)=>userSettings ? userSettings.optInsState.updateOptInsCall : idleState()
);
const getUserDataState = createSelector(getUserSettings, (userSettings)=>{
    return userSettings === null || userSettings === void 0 ? void 0 : userSettings.userDataState;
});
const getUserData = createSelector(getUserDataState, (userDataState)=>{
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.userData;
});
const getCallStatus = createSelector(getUserDataState, (userDataState)=>{
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.updateCalls;
});
const getSupportFeaturesLinks = createSelector(getAuth, (auth)=>auth.supportFeaturesLinks
);

export { getAuth, getAuthType, getBasePath, getCallStatus, getChangedOptIns, getCheckoutRoute, getCustomDomain, getDisableAddressEditing, getDomain, getFormattedRoutes, getOptIns, getOptInsForSignup, getOptInsOnServer, getRoutes, getRouting, getSupportFeaturesLinks, getUpdateOptInsCall, getUserData, getUserDataState, getUserId, getUserSettings, isInitialized, isLoggedIn, isLoggedOut, isUninitialized };
//# sourceMappingURL=selectors.js.map
